/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Project specific Tooltip

*/

function initTooltip() {
    // init
    var $tooltip_modules = $('.tooltip-module');
    var active_class = 'tooltip-module--active';
    var is_mobile = $(window).width() < 768 ? true : false;
    // tooltip trigger
    var $tooltip_objects = $('.tooltip-module__icon-link');
    $tooltip_objects.each(function(){
        var $trigger = $(this);
        var initialized_attr = 'data-trigger-initialized';
        // check for initialized trigger
        var trigger_initialized = $trigger.attr(initialized_attr);
        // NOT initialized yet
        if (typeof trigger_initialized === 'undefined') {
            $trigger.
                on('click',
                function(e){
                    // init
                    e.preventDefault();
                    var $trigger = $(this);
                    // mobile
                    if (is_mobile) {
                        // init
                        var escape_close_method_enabled_class = 'tingle-modal--EscapeClose';
                        var overlay_close_method_enabled_class = 'tingle-modal--OverlayClose';
                        var button_close_method_enabled_class = 'tingle-modal--ButtonClose';
                        var $default_modal = $('.tingle-modal.default-modal');
                        // write content into modal
                        var $content_container = $trigger.siblings('.tooltip-module__content-container');
                        var modal_content = $content_container.find('.tooltip-module__content').html();
                        $default_modal.find('.tingle-modal-box__content').html(modal_content);
                        // show modal
                        $default_modal.removeClass('tingle-modal--noOverlayClose');
                        $default_modal.show();
                        $default_modal.addClass('tingle-modal--visible ' + escape_close_method_enabled_class + ' ' + overlay_close_method_enabled_class + ' ' + button_close_method_enabled_class);
                        // show overlay
                        $(window).trigger('showSiteOverlay');
                        // enable overlay close
                        $default_modal.on('click',function(e){
                            e.stopPropagation();
                            // only close modal if clicked on overlay, and not on modal itself
                            if ($(e.target).hasClass(overlay_close_method_enabled_class)) {
                                default_modal.close();
                            }
                        });
                    }
                    // desktop
                    else {
                        // 1. remove any active tooltip
                        $('.tooltip-module').removeClass(active_class);
                        // 2. set current tooltip to active
                        $trigger.parents('.tooltip-module').addClass(active_class);
                    }
                }
            );
            // mark as initialized
            $trigger.attr(initialized_attr,'');
        }
    });
    // close tooltip
    $('.tooltip-module__close-link').on('click',function(e){
        e.preventDefault();
        $(this).parents('.tooltip-module').removeClass(active_class);
    });
    // ESC close
    $(document).keydown(function(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = evt.key == "Escape";
        } else {
            isEscape = evt.keyCode == 27;
        }
        if (isEscape) {
            $tooltip_modules.removeClass(active_class);
        }
    });
    // click anywhere on document closes tooltip
    if (is_mobile === false) {
        $( document ).on( 'click touchend', function(e){
            // click on tooltip content
            if( $(e.target).hasClass('tooltip-module__content') ) {
                // don't do anything
            }
            // click on tooltip link
            else if( $(e.target).hasClass('tooltip-module__icon-link') ) {
                // don't do anything
            }
            else {
                $tooltip_modules.removeClass(active_class);
            }
        });
    }
}

$(function(){

    // on page load
    initTooltip();

    // custom event
    $(window).on('initTooltip softpage:opened', function() {
        initTooltip();
    });

});




// WEBPACK FOOTER //
// ./static/js/modules/tooltip.js